import React from "react";
import { ENV } from "config/config";
import {
  Button,
  Form,
  Container,
  Row,
  Modal,
  FormGroup,
} from "react-bootstrap";

const SliderModal = ({
  modalCloseHandler,
  setSlider,
  modalType,
  openModal,
  slider,
  submit,
  sliderErrors,
  setSliderErrors,
  fetchGallery,
  imageView,
  fetchContent,
  contentTitle,
  fetchEvents,
  eventTitle,
}) => {
  return (
    <Container fluid>
      {modalType > 0 && (
        <Modal
          className="modal-primary edit-cotnact-modal"
          onHide={modalCloseHandler}
          show={openModal}
        >
          <Modal.Header className="justify-content-center">
            <Row>
              <div className="col-12">
                <h4 className="mb-0 mb-md-3 mt-0">
                  {modalType === 1
                    ? "View"
                    : modalType === 2
                    ? "Add"
                    : modalType === 3
                    ? "Edit"
                    : ""}{" "}
                  Slider
                </h4>
              </div>
            </Row>
          </Modal.Header>
          <Modal.Body>
            <Form className="text-left">
              <Form.Group>
                <label>
                  Image<span>*</span>
                </label>
                <div>
                  <Button
                    className="btn-filled pull-right mt-3"
                    variant="info"
                    onClick={fetchGallery}
                  >
                    Choose Image
                  </Button>
                </div>
              </Form.Group>
              <span className={sliderErrors.image !== "" ? `` : `d-none`}>
                <label className="pl-1">{sliderErrors.image}</label>
              </span>
              {imageView && (
                <Form.Group>
                  <img
                    src={ENV.assetsUrl + "gallery/" + imageView}
                    id="imageUploader"
                    className="image-fluid"
                    style={{ width: "30%", height: "30%" }}
                    alt="gallery-image"
                  />
                </Form.Group>
              )}
              {!imageView && slider?.id && slider?.Gallery?.image && (
                <Form.Group>
                  <img
                    src={ENV.assetsUrl + "gallery/" + slider?.Gallery?.image}
                    id="imageUploader"
                    className="image-fluid"
                    style={{ width: "30%", height: "30%" }}
                    alt="gallery-image"
                  />
                </Form.Group>
              )}

              <Form.Group>
                <label>External Url</label>

                <div className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="isExternal"
                    disabled={modalType === 1}
                    onChange={(e) => {
                      const newIsExternal = !slider.isExternal;
                      setSlider({ ...slider, isExternal: newIsExternal });

                      if (newIsExternal) {
                        setSlider((prevState) => ({
                          ...prevState,
                          contentId: null,
                          eventId: null,
                        }));
                      } else {
                        setSlider((prevState) => ({ ...prevState, url: "" }));
                      }
                    }}
                    checked={slider?.isExternal}
                  />
                  <span className="checkmark"></span>
                </div>
              </Form.Group>
              {slider && !slider.isExternal && (
                <>
                  <Form.Group>
                    <label>Link Type</label>
                    <div className="d-flex align-items-center">
                      <label className="right-label-radio mr-3 mb-2">
                        CMS Content
                        <input
                          name="linkType"
                          disabled={modalType === 1}
                          type="radio"
                          checked={slider?.eventId === null}
                          onChange={(e) => setSlider({ ...slider, contentId: slider.contentId || "", eventId: null })}
                        />
                        <span className="checkmark"></span>
                      </label>
                      <label className="right-label-radio mr-3 mb-2">
                        Event
                        <input
                          name="linkType"
                          disabled={modalType === 1}
                          type="radio"
                          checked={slider?.eventId !== null}
                          onChange={(e) => setSlider({ ...slider, eventId: slider.eventId || "", contentId: null })}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </Form.Group>

                  {slider.eventId === null ? (
                    <>
                      <Form.Group>
                        <label>
                          Link Content<span>*</span>
                        </label>
                        <div>
                          <Button
                            className="btn-filled pull-right mt-3"
                            variant="info"
                            onClick={fetchContent}
                          >
                            Choose Content
                          </Button>
                        </div>
                      </Form.Group>
                      <span
                        className={sliderErrors.contentId !== "" ? `` : `d-none`}
                      >
                        <label className="pl-1">{sliderErrors.contentId}</label>
                      </span>
                      {!slider.isExternal && slider.contentId && (
                        <div>{contentTitle}</div>
                      )}
                    </>
                  ) : (
                    <>
                      <Form.Group>
                        <label>
                          Link Event<span>*</span>
                        </label>
                        <div>
                          <Button
                            className="btn-filled pull-right mt-3"
                            variant="info"
                            onClick={fetchEvents}
                          >
                            Choose Event
                          </Button>
                        </div>
                      </Form.Group>
                      <span
                        className={sliderErrors.eventId !== "" ? `` : `d-none`}
                      >
                        <label className="pl-1">{sliderErrors.eventId}</label>
                      </span>
                      {!slider.isExternal && slider.eventId && (
                        <div>{eventTitle}</div>
                      )}
                    </>
                  )}
                </>
              )}
              {slider && slider.isExternal && (
                <Form.Group>
                  <label>
                    Url <span>*</span>
                  </label>
                  <Form.Control
                    className={sliderErrors.url ? `on-error` : ``}
                    placeholder="Enter url"
                    disabled={modalType === 1}
                    type="text"
                    name="url"
                    onChange={(e) => {
                      setSlider({
                        ...slider,
                        url: e.target.value,
                      });
                      setSliderErrors((prevErrors) => ({
                        ...prevErrors,
                        url: "",
                      }));
                    }}
                    value={slider?.url}
                    required
                  />
                  <span className={sliderErrors.url !== "" ? `` : `d-none`}>
                    <label className="pl-1">{sliderErrors.url}</label>
                  </span>
                </Form.Group>
              )}
              <FormGroup>
                <label>Status</label>
                <div className="d-flex align-items-center">
                  <label className="right-label-radio mr-3 mb-2">
                    Active
                    <input
                      name="isActive"
                      disabled={modalType === 1}
                      type="radio"
                      checked={slider?.isActive}
                      value={slider?.isActive}
                      onChange={(e) => setSlider({ ...slider, isActive: true })}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label className="right-label-radio mr-3 mb-2">
                    Inactive
                    <input
                      name="isActive"
                      disabled={modalType === 1}
                      type="radio"
                      checked={!slider?.isActive}
                      value={!slider?.isActive}
                      onChange={(e) =>
                        setSlider({ ...slider, isActive: false })
                      }
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
              </FormGroup>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button className="outline-button" onClick={modalCloseHandler}>
              Close
            </Button>
            {modalType === 2 || modalType === 3 ? (
              <Button className="btn-filled" onClick={submit}>
                Submit
              </Button>
            ) : (
              ""
            )}
          </Modal.Footer>
        </Modal>
      )}
    </Container>
  );
};

export default SliderModal;
